import client from './client';

export const postsApi = {
  list: (params) => client.get('/posts', { params }).then((r) => r.data),
  get: (id) => client.get(`/posts/${id}`).then((r) => r.data),
  create: (payload) => client.post('/posts', payload).then((r) => r.data),
  update: (id, payload) => client.put(`/posts/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/posts/${id}`).then((r) => r.data),
  // Delete several posts in one request (ownership-scoped server-side).
  bulkRemove: (ids) => client.post('/posts/bulk-delete', { ids }).then((r) => r.data),
  // One-off redistribution across new days/times. Does not touch the business
  // posting schedule; published posts are never moved.
  reschedule: (payload) => client.post('/posts/reschedule', payload).then((r) => r.data),
  approve: (id) => client.post(`/posts/${id}/approve`).then((r) => r.data),
  schedule: (id, payload) =>
    client.post(`/posts/${id}/schedule`, payload).then((r) => r.data),
  publishNow: (id) => client.post(`/posts/${id}/publish-now`).then((r) => r.data),
  // Edit a post that is ALREADY live, one network at a time. Per-network on
  // purpose: the networks hold separate posts with separate ids and separate
  // rules about what may be changed, so there is no single "update the post".
  // A media change on a network that cannot swap an image in place comes back
  // 422 with needs_repost — the caller confirms, then resends allow_repost.
  updateLive: (postId, platformId, payload) =>
    client.post(`/posts/${postId}/platforms/${platformId}/update-live`, payload).then((r) => r.data),
  // Re-attempt ONE failed network in place. 422 with needs_destination_choice
  // + candidates means more than one connected destination could take this
  // post — resend with { asset_id } once the caller picks one.
  retryPlatform: (postId, platformId, payload = {}) =>
    client.post(`/posts/${postId}/platforms/${platformId}/retry`, payload).then((r) => r.data),
  regenerateText: (id, payload) =>
    client.post(`/posts/${id}/regenerate-text`, payload).then((r) => r.data),
  regenerateImage: (id, payload) =>
    client.post(`/posts/${id}/regenerate-image`, payload).then((r) => r.data),
};

export default postsApi;
